import { fromJS } from 'immutable';
import { endLoad, startLoad } from 'portaltransparencia-common/crud/Core.js';

import * as types from './Types.js';

const initialState = fromJS({
  processos: []
});

function processosReducer(state = initialState, action) {
  switch (action.type) {
    case types.PROCESSO_DISCIPLINAR_LIST_START: {
      return startLoad(state);
    }

    case types.PROCESSO_DISCIPLINAR_LIST_SUCCESS: {
      return endLoad(state.set('processos', fromJS(action.payload)));
    }

    case types.PROCESSO_DISCIPLINAR_LIST_ERROR: {
      return endLoad(state);
    }
  }

  return state;
}

export default processosReducer;
